import _extends from "@babel/runtime-corejs3/helpers/extends";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";

var _context, _context2;

import React, { forwardRef, useMemo } from 'react';
import { cx } from 'emotion';
import { useStyles, StyleSheet } from '@rexlabs/styling';
import { omit, memoize } from 'lodash';
var flexTypes = ['flexDirection', 'flexWrap', 'alignItems', 'alignContent', 'alignSelf', 'justifyContent', 'justifySelf', 'flexShrink', 'flex', 'flexAuto', 'flexNone'];
var aliases = {
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  width: 'width',
  height: 'height',
  w: 'width',
  h: 'height'
};

var flexProps = _Object$values(flexTypes);

var spacingProps = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(_Object$keys(aliases)), _toConsumableArray(_Object$values(aliases)));

var styleProps = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(flexProps), _toConsumableArray(spacingProps));

var layoutProps = ['sx', 'sy', 'spacing'];
var defaultStyles = StyleSheet({
  container: {
    boxSizing: 'border-box'
  }
});

function getClasses(x, y) {
  return StyleSheet({
    spacingX: {
      marginLeft: "calc(-".concat(x, "/2)"),
      marginRight: "calc(-".concat(x, "/2)"),
      '& > *': {
        marginLeft: "calc(".concat(x, "/2)"),
        marginRight: "calc(".concat(x, "/2)")
      }
    },
    spacingY: {
      marginTop: "calc(-".concat(y, "/2)"),
      marginBottom: "calc(-".concat(y, "/2)"),
      '& > *': {
        marginTop: "calc(".concat(y, "/2)"),
        marginBottom: "calc(".concat(y, "/2)")
      }
    }
  });
}

var memGetClasses = memoize(getClasses, function (x, y) {
  var _context3;

  return _concatInstanceProperty(_context3 = "".concat(x, "|")).call(_context3, y);
});
var displayName = 'Box';
/**
 * Box is a layout helper to make managing the structure of pages easier and more consistent
 */

export var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      style = _ref.style,
      className = _ref.className,
      sx = _ref.sx,
      sy = _ref.sy,
      spacing = _ref.spacing,
      _ref$Container = _ref.Container,
      Container = _ref$Container === void 0 ? 'div' : _ref$Container,
      rest = _objectWithoutProperties(_ref, ["children", "style", "className", "sx", "sy", "spacing", "Container"]);

  var s = useStyles(defaultStyles, displayName);
  var cleanProps = useMemo(function () {
    var _context4;

    return omit(rest, _concatInstanceProperty(_context4 = []).call(_context4, _toConsumableArray(styleProps), layoutProps));
  }, [rest]);
  var classNames = useMemo(function () {
    var _cx;

    var x = sx || spacing;
    var y = sy || spacing;

    if (typeof x !== 'string') {
      x = "".concat(x, "px");
    }

    if (typeof y !== 'string') {
      y = "".concat(y, "px");
    }

    var classes = memGetClasses(x, y);
    return cx(className, (_cx = {}, _defineProperty(_cx, classes.spacingX, !!sx || !!spacing), _defineProperty(_cx, classes.spacingY, !!sy || !!spacing), _cx));
  }, [sx, sy, spacing, className]);
  var isFlex = useMemo(function () {
    return !!_findInstanceProperty(flexProps).call(flexProps, function (flexType) {
      return rest[flexType];
    });
  }, [rest]);
  var mapStyles = useMemo(function () {
    var base = isFlex ? {
      display: 'flex'
    } : {};
    return _reduceInstanceProperty(styleProps).call(styleProps, function (acc, propName) {
      var prop = rest[propName];

      if (!prop) {
        return acc;
      }

      var value = prop;
      if (!value) return acc;
      var name = aliases[propName] || propName;
      acc[name] = value;
      return acc;
    }, base);
  }, [isFlex, rest]);
  return /*#__PURE__*/React.createElement(Container, _extends({}, cleanProps, s.with('container')({
    style: style,
    className: classNames
  }, // TODO: Fix types
  // @ts-ignore
  mapStyles), {
    ref: ref
  }), children);
});
Box.displayName = displayName;
export default Box;